<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  mode: { type: String, default: 'cards' },
  items: { type: Array, default: () => [] },
  quickReplies: { type: Array, default: () => [] },
});

const { t } = useI18n();

const cardTitle = card =>
  card.title || t('AUTOMATION.INTERACTIVE_MESSAGE.PREVIEW_CARD_PLACEHOLDER');
const actionLabel = action =>
  action.text || t('AUTOMATION.INTERACTIVE_MESSAGE.PREVIEW_ACTION_PLACEHOLDER');
const quickReplyLabel = quickReply =>
  quickReply.title ||
  t('AUTOMATION.INTERACTIVE_MESSAGE.QUICK_REPLY_MESSAGE_PLACEHOLDER');
</script>

<template>
  <div>
    <label
      class="flex items-center gap-1.5 text-sm font-medium text-n-slate-12 mb-2"
    >
      <span class="i-lucide-eye size-4 text-n-slate-10" aria-hidden="true" />
      {{ $t('AUTOMATION.INTERACTIVE_MESSAGE.PREVIEW_LABEL') }}
    </label>
    <div
      class="rounded-xl bg-n-slate-3 dark:bg-n-solid-3 p-4 flex flex-col gap-2.5"
    >
      <div v-if="mode === 'cards'" class="flex gap-2.5 overflow-x-auto pb-1">
        <div
          v-for="(card, index) in items"
          :key="index"
          class="flex flex-col shrink-0 w-40 rounded-xl bg-n-solid-1 shadow-sm overflow-hidden"
        >
          <img
            v-if="card.media_url"
            :src="card.media_url"
            class="h-20 w-full object-cover"
            alt=""
          />
          <div
            v-else
            class="h-20 flex items-center justify-center bg-n-slate-4 text-n-slate-9"
          >
            <span class="i-lucide-image size-5" aria-hidden="true" />
          </div>
          <div class="flex flex-col gap-1 p-2.5">
            <p class="text-xs font-medium text-n-slate-12 line-clamp-2">
              {{ cardTitle(card) }}
            </p>
            <p
              v-if="card.description"
              class="text-[11px] text-n-slate-11 line-clamp-2"
            >
              {{ card.description }}
            </p>
            <div
              v-for="(action, actionIndex) in card.actions"
              :key="actionIndex"
              class="mt-1 text-center text-[11px] font-medium py-1.5 rounded-lg bg-n-alpha-1 text-n-blue-text"
            >
              {{ actionLabel(action) }}
            </div>
          </div>
        </div>
      </div>

      <div v-else class="flex flex-col items-end gap-1.5">
        <span class="text-[11px] text-n-slate-10">
          {{ $t('AUTOMATION.INTERACTIVE_MESSAGE.PREVIEW_REPLY_BUTTONS_LABEL') }}
        </span>
        <div class="flex flex-wrap gap-1.5 justify-end">
          <span
            v-for="(quickReply, index) in quickReplies"
            :key="index"
            class="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-n-solid-1 text-n-blue-text shadow-sm"
          >
            {{ quickReplyLabel(quickReply) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
